import moduleInfo from '../module.json';
import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';

/**
 * Бутстрап модуля Comments (клиент)
 * Регистрирует модуль без навигации (сервисный модуль).
 */
export async function setup(app: AppRuntime) {
  app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
  });

  // Comments - сервисный модуль без UI навигации
  // Навигация пустая, как указано в navigation.tsx
}
